import {Injectable} from "@angular/core";
import {Http, ResponseContentType} from "@angular/http";
import {headersBlob} from "../util/rxjs-functions";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable()
export class RelatorioService {
  constructor(public http: Http) {
  }


  obterRelatorioAguardandoAnalisePorAtividades(situacao: number, atividade: number, lotacao: number) {
    const url = `${environment.apiEndpoint}/relatorio-base/analise-por-atividade/${situacao}/${atividade}/${lotacao}`;

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, options)
      .pipe(
        map(response => {
          return new Blob([response.blob()], {type: 'text/csv'});
        })
      );
  }

  obterRelatorioEmAguardandoAnalisePorAtividades(situacao: number, atividade: number, lotacao: number): Observable<Blob> {
    const url = `${environment.apiEndpoint}/relatorio-base/em-analise-por-atividade/${situacao}/${atividade}/${lotacao}`;

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, options)
      .pipe(
        map(response => {
          return new Blob([response.blob()], {type: 'text/csv'});
        })
      );
  }

  obterRelatorioTurmaCadastradaPorCurso(idCurso: number): Observable<Blob> {
    const url = `${environment.apiEndpoint}/relatorio-base/turma-cadastrada-por-curso/${idCurso}`;

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, options)
      .pipe(
        map(response => {
          return new Blob([response.blob()], {type: 'text/csv'});
        })
      );
  }

  obterEventoCredenciadoPorCapacitadora(cnpj: string, codigoCapacitadora: string): Observable<Blob> {
    let url = `${environment.apiEndpoint}/relatorio-base/evento-credenciado-por-capacitadora`;

    const params = [];
    if (cnpj) { params.push(`cnpj=${encodeURIComponent(cnpj)}`); }
    if (codigoCapacitadora) { params.push(`codigoCapacitadora=${encodeURIComponent(codigoCapacitadora)}`); }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, options).pipe(
        map(response => {
          // Transforma a resposta em um Blob
          return new Blob([response.blob()], { type: 'application/vnd.ms-excel' });
        })
    );
  }

  obterRelatorioProfissionaisPorEvento(idEvento: number) {
    const url = `${environment.apiEndpoint}/relatorio-base/profissionais-por-evento/${idEvento}`;

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, headersBlob({'Content-Type': 'application/vnd.ms-excel'}))
      .pipe(
        map(response => {
          return new Blob([response.blob()]);
        })
      );
  }

  obterRelatorioProfissionaisPorCurso(idCurso: number) {
    const url = `${environment.apiEndpoint}/relatorio-base/profissionais-por-curso/${idCurso}`;

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, headersBlob({'Content-Type': 'application/vnd.ms-excel'}))
      .pipe(
        map(response => {
          return new Blob([response.blob()]);
        })
      );
  }

  obterRelatorioEdicaoDeEvento(idCurso: number) {
    const url = `${environment.apiEndpoint}/relatorio-base/edicao-de-evento/${idCurso}`;

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, headersBlob({'Content-Type': 'application/vnd.ms-excel'}))
        .pipe(
            map(response => {
              return new Blob([response.blob()]);
            })
        );
  }

  obterCursoCredenciadoPorCapacitadora(cnpj: string, codigoCapacitadora: string): Observable<Blob> {
    let url = `${environment.apiEndpoint}/relatorio-base/curso-credenciado-por-capacitadora`;

    const params = [];
    if (cnpj) { params.push(`cnpj=${encodeURIComponent(cnpj)}`); }
    if (codigoCapacitadora) { params.push(`codigoCapacitadora=${encodeURIComponent(codigoCapacitadora)}`); }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, options).pipe(
        map(response => {
          // Transforma a resposta em um Blob
          return new Blob([response.blob()], { type: 'application/vnd.ms-excel' });
        })
    );
  }

  obterRelatorioAtividadeJulgadaMembroComissao(nome: number, atividade: number, lotacao: number, anoExercicio: number): Observable<Blob> {
    let url = `${environment.apiEndpoint}/relatorio-base/atividade-julgada-por-membro-comissao/${nome}/${atividade}/${lotacao}`;

    const params = [];
    if (anoExercicio) { params.push(`anoExercicio=${anoExercicio}`); }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    const options = {
      responseType: ResponseContentType.Blob
    };

    return this.http.get(url, options)
      .pipe(
        map(response => {
          return new Blob([response.blob()], {type: 'text/csv'});
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/relatorio.service.ts